// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"9521":"afb6f13418c60a00bd2d","9819":"390e52faaf166516d6e0"}[chunkId] + ".css";
};